import { render, staticRenderFns } from "./westernWaring.vue?vue&type=template&id=33b1dcc2&scoped=true"
import script from "./westernWaring.vue?vue&type=script&lang=js"
export * from "./westernWaring.vue?vue&type=script&lang=js"
import style0 from "./westernWaring.vue?vue&type=style&index=0&id=33b1dcc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1dcc2",
  null
  
)

export default component.exports